import { Controller } from "@hotwired/stimulus"

// Drawer that mounts into a turbo-frame container.
//
// Lifecycle: when the frame is populated with drawer content (rendered
// by tw_drawer), the new DOM mounts this controller as the wrapper.
// Closing the drawer clears the container's innerHTML, which removes
// the drawer from the page until the next link triggers a re-render.
//
// Listens for:
//   - X button: data-action="click->drawer#dismiss"
//   - Backdrop:  data-action="click->drawer#dismiss"
//   - Escape key: connected globally via keydown listener
export default class extends Controller {
  static targets = ["container"]

  connect() {
    // Bind once so add/removeEventListener pair to the same function.
    this.handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleKeydown)
  }

  dismiss() {
    if (this.hasContainerTarget) {
      this.containerTarget.innerHTML = ""
    } else {
      // Fallback if the helper renders without a target attr (defensive).
      this.element.innerHTML = ""
    }
  }

  handleKeydown(event) {
    if (event.key !== "Escape") return
    if (this.isOpen()) {
      event.preventDefault()
      this.dismiss()
    }
  }

  isOpen() {
    const root = this.hasContainerTarget ? this.containerTarget : this.element
    return root.querySelector("[data-drawer-panel]") !== null
  }
}
